// eslint-disable-next-line no-undef
$(document).ready(() => {
  const prices = document.querySelectorAll('.product-price-value');
  const productCard = document.querySelectorAll('.product-card');

  prices.forEach((el) => {
    if (el.innerHTML.trim().length > 6) {
      const elements = el.closest('.card, .price.my-5');
      const productPromoTag = elements.querySelector('.product-promo-tag');

      elements.classList.add('wide');

      if (productPromoTag) {
        productPromoTag.remove();
      }

    }
  });

  productCard.forEach((el) => {
    if (!el.querySelector('.product-promo-tag')) {
      el.classList.add('wide');
    }
  });
});
